import { Droppable } from 'react-beautiful-dnd';
import React from 'react';
import PropTypes from 'prop-types';

const getListStyle = isDraggingOver => ({
  border: isDraggingOver ? '2px solid #f4cf28' : 'inherit'
});

const DroppableList = props => (
  <Droppable
    type={props.type}
    droppableId={props.droppableId}
    direction={props.direction}
  >
    {(provided, snapshot) => (
      <div
        className={props.className}
        ref={provided.innerRef}
        style={getListStyle(snapshot.isDraggingOver)}
        {...provided.droppableProps}
        {...provided.droppablePlaceholder}
      >
        {props.children}
        {provided.placeholder}
      </div>
    )}
  </Droppable>
);

DroppableList.propTypes = {
  droppableId: PropTypes.string.isRequired,
  direction: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

DroppableList.defaultProps = {
  direction: 'vertical',
  className: '',
  type: 'DEFAULT'
};

export default DroppableList;
